export default __webpack_public_path__ + "static/media/Monitoring Agency Report.9093342e.pdf";